import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

// Import API client to register interceptors
import './api/client'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
